import React from 'react'; 
import { FaTiktok } from "react-icons/fa";

const ContactInfoCard = ({ t }) => {
	
	return(
		<>
			<div className="bg-primary text-white contact-info-bx">
				<div className="heading-bx left mb-s6">
					<h3 className="m-b10 title-head">{t("contact.info")} <span> {t("contact.contact")}</span></h3>
				</div>
				<div className="widget widget_getintuch">	
					<ul>
						<li><i className="ti-location-pin"></i>8725 NW 18th Terrace · Ste 303 · DORAL, FL 33172</li>
						<li><i className="ti-mobile"></i>+1 305 513 8760 </li>
						<li><i className="ti-email"></i>mercadeo@visiontravel.net</li>
					</ul>
				</div>
				<h5 className="m-t0 m-b20">{t("contact.follow")}</h5>
				<ul className="list-inline contact-social-bx m-b0">
					<li><a href='https://www.facebook.com/Visionbizofficial' target="_blank" rel="noreferrer" className="btn outline radius-xl"><i className="fa fa-facebook"></i></a></li>
					<li><a href='https://www.instagram.com/accounts/login/?next=/visionbizofficial/' rel="noreferrer" target="_blank" className="btn outline radius-xl"><i className="fa fa-instagram"></i></a></li>
					<li><a href='https://www.youtube.com/visiontravelofficial' target="_blank" rel="noreferrer" className="btn outline radius-xl"><i className="fa fa-youtube"></i></a></li>
					<li><a href='https://www.tiktok.com/@visionbizofficial?' target="_blank" rel="noreferrer" className="btn outline radius-xl"><i><FaTiktok /></i></a></li>
				</ul>
			</div>
		</>
	);
}

export default ContactInfoCard;